import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import course_store from "../store/course_store";
import student_store from "../store/student_store";
import CurrUser from "../functions/UserAuth";
import admin_store from "../store/admin_store";
import supervisor_store from "../store/supervisor_store";
import courseset_store from "../store/courseset_store";
import Cookies from "js-cookie";
import major_store from "../store/major_store";
import cohort_store from "../store/cohort_store";
import Papa from "papaparse";
import styles from "../css/styles.module.css";
import { Dropdown } from "react-bootstrap";
import Card_Component from '../component/Card_Component'
function Home_Page() {
  const courses = course_store((state) => state.courses);
  const student = student_store((state) => state.student);
  const getStudent = student_store((state) => state.getstudent);
  const getAdmin = admin_store((state) => state.getAdmin);
  const getMajorCount = major_store((state) => state.getMajorCount);
  const getCohortCount = cohort_store((state) => state.getCohortCount);
  const getSupervisorCount = supervisor_store(
    (state) => state.getSupervisorCount
  );
  const getStudentCount = student_store((state) => state.getStudentCount);
  const getcoursesetCount = courseset_store((state) => state.getcoursesetCount);
  const getcourseCount = course_store((state) => state.getcourseCount);
  // const getMajorCount = major_store((state) => state.getMajorCount)
  const majorCount = major_store((state) => state.majorCount);
  const cohortCount = cohort_store((state) => state.cohortCount);
  const studentCount = student_store((state) => state.studentCount);
  const supervisorCount = supervisor_store((state) => state.supervisorCount);
  const coursesetCount = courseset_store((state) => state.coursesetCount);
  const courseCount = course_store((state) => state.courseCount);
  const getSupervisor = supervisor_store((state) => state.getSupervisor);
  const supervisor = supervisor_store((state) => state.supervisor);
  const admin = admin_store((state) => state.admin);
  const getCourses = course_store((state) => state.getCourses);
  const logoutStudent = student_store((state) => state.logoutStudent);
  const logoutSupervisor = supervisor_store((state) => state.logoutSupervisor);
  const logoutAdmin = admin_store((state) => state.logoutAdmin);

  const [isOpen, setIsOpen] = useState(false);
  let majorId = Cookies.get("major") ?? "";
  let cohortId = Cookies.get("cohort") ?? "";
  if (majorId) majorId = JSON.parse(majorId ?? {});
  if (cohortId) cohortId = JSON.parse(cohortId ?? {});

  let [major, setMajor] = useState([majorId]);
  let [cohort, setCohort] = useState([cohortId]);

  const currUser = CurrUser();

  const navigate = useNavigate();

  // add user store function like edit for editing student informations
  const ref = useRef();

  useEffect(() => {
    // getCourses(currUser?.token)
    if (currUser == "student") {
      getStudent();
    } else if (currUser == "supervisor") {
      getSupervisor();
    } else if (currUser == "admin") {
      getMajorCount();
      getCohortCount();
      getSupervisorCount();
      getcoursesetCount();
      getcourseCount();
      getStudentCount();
    }
  }, []);
  const suffix = process.env.REACT_APP_SUFFIX_ROUTE;
  let [page, setPage] = useState([1]);
  let [search, setSearch] = useState([]);

  let liArr = [];
  const i = courses.totalCount / 15 + (courses.totalCount % 15 > 0 ? 1 : 0);
  for (let index = 1; index <= i; index++) {
    let classname = page == index ? "page-item active" : "page-item";
    const newLocal = () => {
      setPage(index);
    };
    liArr.push(
      <li key={index} onClick={newLocal} className={classname}>
        <span className="page-link">{index}</span>
      </li>
    );
  }

  function onChange(e) {
    let word = e.target.value;
    const result = courses.data.filter(
      (course) =>
        (course.name &&
          course.name.toLowerCase().includes(word.toLowerCase())) ||
        course?.id == word
    );
    setSearch(result);

    if (word === "") {
      setSearch([]);
    }
  }

  let [selectedCourses, setSelectedCourses] = useState([]);

  const calculateSelectedCourse = (course) => {
    const result = selectedCourses.filter((item) => item.id != course.id);
    if (result.length == selectedCourses.length)
      setSelectedCourses([...selectedCourses, course]);
    else setSelectedCourses([...result]);
  };

  const getIndexSelectedCourse = (id) => {
    // const result = selectedCourses.find(cc => cc.id == id )
    const result = selectedCourses.indexOf(id);
    if (result == -1) return -1;
    return result + 1;
  };

  const logout = () => {
    logoutStudent();
    logoutSupervisor();
    logoutAdmin();
    navigate(`${suffix}/login`);
  };

  const image = Cookies.get("image");
  const name = Cookies.get("name");



  return (
    <>
      <div className="Courses">
        <div className="page-heading">
          <div className="d-flex bd-highlight">
            <div className="pt-2 flex-grow-1 bd-highlight"></div>
            <div className="p-2 bd-highlight  ">
              <Dropdown>
                <Dropdown.Toggle variant="primary " id="dropdown-basic">
                  {name ?? "profile"} &nbsp;&nbsp;&nbsp;
                  {image == "." ? (
                    <i
                      className={`bi bi-person me-4 ${styles.fontSize_20}`}
                    ></i>
                  ) : (
                    <div className="avatar avatar-md">
                      <img src={`${image}`} />
                    </div>
                  )}{" "}
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  {/* {currUser == 'student' &&
                    <Dropdown.Item onClick={() => setIsOpen(true)}>
                      <i className='fas fa-book text-primary'></i>
                      &nbsp; Change your major{' '}
                    </Dropdown.Item>
                  } */}
                  <Dropdown.Item onClick={async () => logout()}>
                    {/* <i className="fa fa-sign-out fa_custom fa-1x"></i> */}
                    <i className="fas fa-sign-out-alt text-primary"></i>
                    &nbsp; Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
        <div className="page-content-home">
          {currUser == "student" && (
            <div className="row Courses-item ">
              {Card_Component("Your name: ", student?.name ?? "")}
              {Card_Component("Your email: ", student?.email ?? "")}
              {Card_Component("Your major: ", student?.majors?.[0]?.name ?? "")}
              {Card_Component("Your cohort: ", student?.cohorts?.[0]?.name ?? "")}
              {Card_Component(
                "Your advisor name & address:",
                (student?.supervisors?.[0]?.name ?? "") +
                  " - " +
                  (student?.supervisors?.[0]?.location ?? "")
              )}
              {Card_Component(
                "Your advisor email: ",
                student?.supervisors?.[0]?.email ?? ""
              )}
            </div>
          )}

          {currUser == "supervisor" && (
            <div className="row Courses-item ">
              {Card_Component("Your name: ", supervisor?.name ?? "")}
              {Card_Component("Your email: ", supervisor?.email ?? "")}
              {Card_Component("Student number: ", supervisor?.student?.length ?? "")}
            </div>
          )}

          {currUser == "admin" && (
            <div className="row Courses-item ">
              {Card_Component("Majors count: ", majorCount ?? "")}
              {Card_Component("Cohorts count: ", cohortCount ?? "")}
              {Card_Component("Students count: ", studentCount ?? "")}
              {Card_Component("Advisors count: ", supervisorCount ?? "")}
              {Card_Component("Courses-set count: ", coursesetCount ?? "")}
              {Card_Component("Courses count: ", courseCount ?? "")}
            </div>
          )}
        </div>
      </div>

      {/* Add & Edit Modal 
        <Choose_Major_Modal
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          id={student?.id ?? -1}
          major={major??[]}
          cohort={cohort??[]}
          setMajor={setMajor}
          setCohort={setCohort}
        /> */}
    </>
  );
}

export default Home_Page;
